import classNames from 'classnames'
import { FC, MouseEvent, PropsWithChildren, useRef } from 'react'

import { Scrollbar } from '@ui/v2/Scrollbar/Scrollbar'

import styles from './DropdownList.module.scss'

export interface DropdownListProps {
  className?: string
  variant?: 'default' | 'compact'
  onMouseOver?: (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void
}

export const DropdownList: FC<PropsWithChildren<DropdownListProps>> = (props) => {
  const { className, variant = 'default', children, onMouseOver } = props
  const scrollRef = useRef<HTMLDivElement | null>(null)

  return (
    <>
      <div
        ref={scrollRef}
        className={classNames(styles.dropdownList, className, 'custom-scrollbar-y-active', {
          [styles.compact]: variant === 'compact',
        })}
        onMouseOver={onMouseOver}
      >
        {children}
      </div>
      <Scrollbar parentRef={scrollRef} orientation='vertical' size='sm' />
    </>
  )
}
